module.exports = __webpack_public_path__ + "static/img/progressbar.3990e106.gif";